import { motion } from "framer-motion";
import { PAUSE_LINES } from "@/content";

const Pause = () => (
  <section
    data-testid="interactive-pause-section"
    className="bg-cream text-charcoal relative overflow-hidden"
  >
    <div
      aria-hidden="true"
      className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[60vw] max-w-[700px] aspect-square rounded-full bg-[radial-gradient(circle,rgba(76,144,128,0.20),transparent_65%)] blur-3xl anim-orb"
    />
    <div className="relative mx-auto max-w-3xl px-6 md:px-10 min-h-[90vh] flex flex-col items-center justify-center text-center py-32">
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-30%" }}
        transition={{ duration: 1.6 }}
        className="eyebrow mb-16"
        data-testid="pause-eyebrow"
      >
        Before you keep scrolling…
      </motion.p>

      <div className="space-y-8 md:space-y-10" data-testid="pause-lines">
        {PAUSE_LINES.map((line, i) => (
          <motion.p
            key={line}
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-30%" }}
            transition={{ duration: 1.6, delay: 1.2 + i * 1.5, ease: [0.22, 1, 0.36, 1] }}
            className="font-serif italic text-2xl md:text-4xl leading-snug text-charcoal/90"
            data-testid={`pause-line-${i}`}
          >
            {line}
          </motion.p>
        ))}
      </div>
    </div>
  </section>
);

export default Pause;
